import { render, staticRenderFns } from "./genealogyArticleList.vue?vue&type=template&id=d1537000&scoped=true&"
import script from "./genealogyArticleList.vue?vue&type=script&lang=js&"
export * from "./genealogyArticleList.vue?vue&type=script&lang=js&"
import style0 from "./genealogyArticleList.vue?vue&type=style&index=0&id=d1537000&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./genealogyArticleList.vue?vue&type=style&index=1&id=d1537000&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1537000",
  null
  
)

export default component.exports